export const POC_LISTING = "POC_LISTING";
export const UPDATE_POC_STATUS = "UPDATE_POC_STATUS";
